// #123: whom a new project is assigned to once its role is chosen. A role held
// by one person gives the right answer without a click; with several holders,
// or none, nobody is guessed and the form says why.
export type MemberProposal =
  | { kind: 'single'; memberId: string }
  | { kind: 'several'; names: string[] }
  | { kind: 'vacant' }

interface Holder {
  id: string
  name: string
}

export function proposeMember(holders: readonly Holder[]): MemberProposal {
  const unique = holders.filter(
    (holder, index) => holders.findIndex((h) => h.id === holder.id) === index
  )
  if (unique.length === 1) return { kind: 'single', memberId: unique[0].id }
  if (unique.length === 0) return { kind: 'vacant' }
  return { kind: 'several', names: unique.map((holder) => holder.name) }
}
